module.exports = __webpack_public_path__ + "static/media/dinamic-playlists-icon.1a96d645.svg";